import { Button } from '@/vibes/mom/primitives/button';
import { Image } from '~/components/image';

interface Props {
  title?: string;
  subtitle?: string;
  ctaLabel?: string;
  ctaAction?: () => void | Promise<void>;
}

export function Error({
  title = 'Something went wrong!',
  subtitle = 'Well, this is awkward… there’s a hiccup on our end. Please try again!',
  ctaLabel = 'Try again',
  ctaAction,
}: Props) {
  return (
    <section className="@container">
      <div className="container mx-auto flex flex-col items-center justify-center gap-6 px-6 py-6 md:flex-row md:py-12">
        <div>
          <Image
            alt="Monkies in the server room"
            className="aspect-square object-contain md:aspect-auto"
            height={500}
            src="/images/monkies-server.png"
            width={420}
          />
        </div>
        <div className="max-w-lg">
          <h1 className="mb-3 text-pretty font-heading text-2xl font-medium leading-none @xl:text-3xl @4xl:text-4xl">
            {title}
          </h1>
          <p className="text-pretty text-lg text-contrast-500">{subtitle}</p>
          {ctaAction && (
            <Button
              className="mt-4"
              onClick={ctaAction}
              size="large"
              type="submit"
              variant="primary"
            >
              {ctaLabel}
            </Button>
          )}
        </div>
      </div>
    </section>
  );
}
